import React from "react";
import { useHistory } from "react-router-dom";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../common/api/master-api/file-records/useFileRecordApi";
import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { ciFileRecordsRoute } from "../../../../ContentIngestionRoutes";
import { isFileRecordRemovable } from "../../../remove/shouldRemoveButtonBeDisabled";
import { useFileRecordDetailsState } from "../../hooks/useFileRecordDetailsState";
import { RemoveFileRecordDetailsDialog } from "./RemoveFileRecordDetailsDialog";

interface RemoveFileRecordDetailsButtonProps {
    itemId: string;
}

export const RemoveFileRecordDetailsButton: React.VFC<RemoveFileRecordDetailsButtonProps> = ({
    itemId
}: RemoveFileRecordDetailsButtonProps) => {
    const { removeFileRecord } = useFileRecordApi();

    const history = useHistory();

    const goToFileRecordListing = () => history.push(ciFileRecordsRoute.path);

    const { fileRecordDetails } = useFileRecordDetailsState();

    const { isOpen, onClose, onOpen } = useDisclosure();

    const handleConfirmation = async () => {
        await removeFileRecord({ fileRecordId: itemId });

        goToFileRecordListing();

        onClose();
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiAdmin]}>
            <CommandBarButton
                text="Remove"
                icon="Delete"
                onClick={onOpen}
                disabled={
                    !isFileRecordRemovable({
                        status: fileRecordDetails.status,
                        isNotificationApproved: fileRecordDetails.isNotificationApproved
                    })
                }
                testId="file-record-remove-button"
            />
            <RemoveFileRecordDetailsDialog confirm={handleConfirmation} isOpen={isOpen} onClose={onClose} />
        </AuthorizationWrapper>
    );
};
